import { Link } from 'react-router-dom';

function Footer(params) {
    return (
        <div className="footer">
            <Link to="/impressum">Impressum</Link>
        </div>
    );
}

export default Footer